import { render, staticRenderFns } from "./AboutLexin.vue?vue&type=template&id=e9f3e018&"
import script from "./AboutLexin.vue?vue&type=script&lang=js&"
export * from "./AboutLexin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports